import { FC, SVGProps } from 'react';

export const EmailIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			d='M18.125 5.3125C18.125 4.45312 17.3938 3.75 16.5 3.75H3.5C2.60625 3.75 1.875 4.45312 1.875 5.3125V14.6875C1.875 15.5469 2.60625 16.25 3.5 16.25H16.5C17.3938 16.25 18.125 15.5469 18.125 14.6875V5.3125ZM16.5 5.3125L10 9.21875L3.5 5.3125H16.5ZM16.5 14.6875H3.5V6.875L10 10.7812L16.5 6.875V14.6875Z'
			fill='currentColor'
		/>
	</svg>
);
